import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { http } from "@/lib/api";
import { useAuth } from "@/lib/auth";

/**
 * Recruiter must accept the Recruiter Access Agreement (current active version)
 * before reaching any recruiter dashboard route.
 * super_admin + tester_admin bypass.
 */
export default function RecruiterGate({ children }) {
  const { user } = useAuth();
  const [status, setStatus] = useState("checking"); // checking | ok | needs-sign

  useEffect(() => {
    if (!user) return;
    if (user.role !== "recruiter") {
      setStatus("ok");
      return;
    }
    http.get("/legal/me/status")
      .then(({ data }) => {
        if (data?.recruiter_agreement?.accepted) setStatus("ok");
        else setStatus("needs-sign");
      })
      .catch(() => setStatus("ok")); // fail-open on infra blip
  }, [user]);

  if (status === "checking") return <div className="p-12 text-center text-white/40">Loading…</div>;
  if (status === "needs-sign") return <Navigate to="/onboarding/recruiter-agreement" replace />;
  return children;
}
